<template>
  <div>
    <h1 class="text-shadow font-Kontesa font-extrabold text-white">
      <slot />
    </h1>
  </div>
</template>
